import * as React from 'react'

export const SearchIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path
        id="Path_6118"
        data-name="Path 6118"
        d="M936.123-119.861c.065-.4.105-.815.2-1.213a7.77,7.77,0,0,1,3.569-5,7.646,7.646,0,0,1,6.4-.865,7.683,7.683,0,0,1,4.482,3.415,7.734,7.734,0,0,1,1.176,4.876,7.815,7.815,0,0,1-1.19,3.5c-.083.132-.171.261-.311.455a.94.94,0,0,1,.2.121q2.483,2.483,4.958,4.975a1.932,1.932,0,0,1,.433.616,1.27,1.27,0,0,1-1.158,1.691,1.352,1.352,0,0,1-1.126-.428q-2.482-2.5-4.971-4.989a1.2,1.2,0,0,1-.123-.173c-.286.175-.524.333-.772.471a7.592,7.592,0,0,1-6.913.407,7.717,7.717,0,0,1-4.348-4.542,7.521,7.521,0,0,1-.475-2.11.558.558,0,0,0-.031-.11Zm13.989.537a6.063,6.063,0,0,0-6.064-6.072,6.056,6.056,0,0,0-6.054,6.079,6.065,6.065,0,0,0,6.062,6.076A6.073,6.073,0,0,0,950.112-119.324Z"
        transform="translate(-936.123 127.283)"
      />
    </svg>
  )
}
